@if (popoverOrigin(); as origin) {
  <glxy-popover
    [origin]="origin"
    [isOpen]="show()"
    [positions]="positions()"
    [hasArrow]="true"
    [padding]="title() ? 'large' : 'small'"
    [highContrast]="highContrast()"
  >
    @if (title(); as tooltipTitle) {
      <glxy-popover-title>
        {{ tooltipTitle | translate }}
      </glxy-popover-title>
    }
    @if (text(); as tooltipText) {
      <span>{{ tooltipText | translate }}</span>
    }
  </glxy-popover>
}
